module.exports = __webpack_public_path__ + "static/media/icon-4.df6456c9.png";